module.exports = __webpack_public_path__ + "static/media/pt-aigfutura-bolditalic-webfont.a406cf37.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pt-aigfutura-bolditalic-webfont.eot
// module id = 102
// module chunks = 3